import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  // 🧠 Načtení košíku z localStorage po otevření stránky
  useEffect(() => {
    const storedCart = localStorage.getItem("visionhome_cart");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  // 💾 Ukládání košíku do localStorage při každé změně
  useEffect(() => {
    localStorage.setItem("visionhome_cart", JSON.stringify(cartItems));
  }, [cartItems]);

  // ➕ Přidání produktu do košíku
  const addToCart = (product, quantity) => {
    setCartItems((prevItems) => {
      const existing = prevItems.find((item) => item.sku === product.sku);
      if (existing) {
        return prevItems.map((item) =>
          item.sku === product.sku
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prevItems, { ...product, quantity }];
    });
  };

  // 🗑️ Vymazání košíku
  const clearCart = () => setCartItems([]);

  // 💰 Celková cena
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.unit_price_with_vat * item.quantity,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        clearCart,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
